import { render, staticRenderFns } from "./TableRiskAppraisal.vue?vue&type=template&id=85800c86&scoped=true&"
import script from "./TableRiskAppraisal.vue?vue&type=script&lang=js&"
export * from "./TableRiskAppraisal.vue?vue&type=script&lang=js&"
import style0 from "./TableRiskAppraisal.vue?vue&type=style&index=0&id=85800c86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85800c86",
  null
  
)

export default component.exports